import { usePublicApi } from "api/setup";
import { ApiError } from "api/shared";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

type Image = {
  image: {
    src: string;
    alt: string;
  };
};

export type LogoResponse = {
  logo: {
    full?: Image;
    square: Image;
  };
  sourceId: string;
};

export const useGetLogoQuery = (platformKey: string) =>
  usePublicApi<LogoResponse, ApiError>({
    url: formatUrl(api.integrations.branding, { platformKey }),
  });
